<template>
  <layout-content>
    <div class="z-card pt-0 px-5 py-5">
      <z-form ref="form" tag="div">
        <z-form-group>
          <z-form-input class="col-9 pl-0 pt-5 pb-0" :rules="{ required: true }">
            <v-text-field
              v-model="name"
              :label="$t('projects.create_task.field.name')"
              hide-details="auto"
              outlined
              dense
              height="30"
              :placeholder="$t('projects.create_task.field.placeholder')"
            />
          </z-form-input>
          <p v-if="project_is_created" class="form-input__error">Проект с таким названием уже создан</p>
        </z-form-group>
        <div class="add-source">
          <h3>{{ $t('projects.create_task.field.task_source.title') }}</h3>
          <p>{{ $t('projects.create_task.field.task_source.text') }}</p>
          <div class="mt-5">
            <vuex-table
              v-if="visibility"
              :fields="fields"
              :show_header="false"
              table_store="sources/table"
              :filter_items="sources"
            >
              <template slot="actions" slot-scope="{ item }">
                <!-- 123 -->
                <!-- {{ items_id.indexOf(item.id) != -1 }} -->
                <table-control type="code" :visible="displayed(item.id)" @click="get_api(item)" />
                <table-control type="edit" @click="edit_source(item)" />
                <table-control type="trash" @click="remove(item)" />
              </template>
            </vuex-table>
          </div>
          
          <v-btn 
            class="btn-cancel ml-0"
            slot="footer-ok"
            color="#D6E2EF"
            size="large"
            @click="add_source"
          >
            {{ $t('projects.create_task.field.add_source') }}
          </v-btn>
        </div>
        <div class="add-source__actions">
          <v-btn 
            class="btn-cancel" 
            @click="cancel"
            color="#fff"
          >
            {{ $t('shared.component.button.cancel') }}
          </v-btn>
          <v-btn
            class="btn-success"
            raised
            slot="footer-ok"
            color="#394858"
            size="large"
            :loading="is_loading"
            @click="save"
          >
            {{ $t('shared.component.button.save') }}
          </v-btn>
        </div>
      </z-form>
    </div>
  </layout-content>
</template>

<script>
  import router from '@/plugins/vue-router';
  import { mapActions } from 'vuex';
  import { SourceModalService } from '@projects/modals/SourceModalSerivice';
  import { SourceService } from '@projects/services/SourceService';
  import { ProjectsService } from '@projects/services/ProjectsService';

  export default {
    data: () => ({
      name: '',
      old_name: '',
      sources: [],
      is_edit: false,
      is_loading: false,
      projects_list: '',
      project_is_created: false,
      project_exists: false,
      items_id: [],
      exist_name: []
    }),

    computed: {
      visibility() {
        if(this.sources.length) {
          return true;
        } else {
          return this.$store.getters[`sources/table/data`].some(data => data.project_id == this.$route.params.id);
        }
      },
      fields() {
        return [
          {
            key: 'name',
            label: this.$t('projects.sources.table.field.name'),
            thStyle: { width: '200px' }
          },
          {
            key: 'type',
            label: this.$t('projects.sources.table.field.type.title'),
            thStyle: { width: '100px' },
            formatter: value => this.$t(`projects.sources.table.field.type.${value}`)
          },
          {
            key: 'created_at',
            label: this.$t('projects.sources.table.field.created_at'),
            thStyle: { width: '200px' }
          },
          {
            key: 'tasks_count',
            label: this.$t('projects.sources.table.field.tasks_count'),
            thStyle: { width: '120px' }
          },
          {
            key: 'tasks_today_count',
            label: this.$t('projects.sources.table.field.tasks_today_count'),
            thStyle: { width: '140px' }
          },
          {
            key: 'group.name',
            label: this.$t('projects.sources.table.field.user_group'),
            thStyle: { width: '120px' }
          },
          {
            key: 'actions',
            label: '',
            class: 'text-right',
            thStyle: { width: '200px' }
          }
        ];
      }
    },

    created() {
      ProjectsService.getList().then(resp => this.projects_list = resp.data);
      if (this.$route.params.id) {
        this.is_edit = true;
        this.get_current_project(this.$route.params.id);
      }
    },

    methods: {
      ...mapActions('projects/table', ['setSources', 'fetchSources']),
      displayed(id) {
        return this.items_id.indexOf(id) == -1;
      },
      add_source() {
        SourceModalService.create(this.exist_name).on('success', data => {
          this.exist_name.push(data.name)
          if (this.is_edit) {
            const params = {
              group_id: data.group_id,
              name: data.name,
              type: data.type,
              project_id: this.$route.params.id
            }
            SourceService.createSource(params).then(resp => {
              this.items_id.push(resp.id);
              this.sources.push(resp);
              this.sync_sources();
              // Object.assign(resp, this.sources);
              // this.sync_sources();
            });
          } else {
            this.sources.push(data);
            // Object.assign(data, this.sources);
          }
        });
      },

      create_source(project_data) {
        const sources = this.sources;

        sources.forEach(function(item) {
          const params = {
            group_id: item.group_id,
            name: item.name,
            type: item.type,
            project_id: project_data.id
          }

          SourceService.createSource(params)
            .then(() => {
              this.sync_sources();
            })
            .catch(e => {
              this.$noty.server_error(e);
              this.$emit('fail', e);
            });
        });

        router.push({ name: 'projects' });
      },

      get_current_project(id) {
        ProjectsService.getProjectItem(id)
          .then(resp => {
            this.name = resp.name;
            this.old_name = resp.name;
            this.get_sources_list(resp.id);
          })
          .catch((error) => {
            this.$noty.server_error(error);
          })
      },

      get_sources_list(id) {
        SourceService.getList(id).then(resp => {
          this.sources = [];
          const sources = resp.data;

          sources.forEach((source) => {
            if (source.project_id === id) {
              this.sources.push(source);
            }
          });
        })
      },

      get_api(item) {
        SourceModalService.view_api(item);
      },

      edit_project(params) {
        const id = this.$route.params.id;
        ProjectsService.editProject(id, params)
          .then(() => {
            this.is_loading = false;
            router.push({ name: 'projects' });
          })
          .catch(error => {
            this.$noty.server_error(error);
          })
      },

      compare_names_projects() {
        this.projects_list.every(item => {
          if ( (this.name === item.name) && (this.old_name != this.name) )  {
            this.project_is_created = true;
            this.project_exists = true;
            return false;
          } else {
            this.project_is_created = false;
            this.project_exists = false;
          }
        });
      },

      save() {
        this.compare_names_projects();
        if (this.project_exists === true) return false;

        const params = {
          name: this.name
        }

        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_loading = true;
            if (this.is_edit) {
              this.edit_project(params);
            } else {
              ProjectsService.createProject(params)
                .then(resp => {
                  this.create_source(resp);
                })
                .catch(error => {
                  this.$noty.server_error(error);
                })
            }
          }
        });
      },

      edit_source(item) {
        SourceModalService.edit(item).on('success', resp => {
          const sources = this.sources;

          if (!this.is_edit) {
            sources.forEach((source, i) => {
              if (source.name === resp.name_old) {
                this.sources[i].name = resp.name;
                this.sources[i].group.name = resp.group.name;
                this.sources[i].type = resp.type;
              }
            });
          } else {
            const params = {
              name: resp.name,
              group_id: resp.group_id
            }

            SourceService.editSource(item.id, params)
              .then(() => {
                this.sync_sources();
              })
              .catch((error) => {
                this.$noty.server_error(error);
              });
          }
        });
      },

      remove(item) {
        const sources = this.sources;

        if (this.is_edit) {
          SourceModalService.remove(item.id, item).on('success', () => {
            SourceService.removeSource(item.id);
            this.sync_sources();
          });
        } else {
          SourceModalService.remove(item.id, item).on('success', () => {
            sources.forEach((source, i) => {
              if (source.group_id === item.group_id) this.sources.splice(i, 1);
            });
          });
        }
      },

      sync_sources() {
        this.get_current_project(this.$route.params.id);
      },

      cancel() {
        if(this.items_id.length) {
          this.items_id.forEach(id => SourceService.removeSource(id));
        }
        this.is_loading = false;
        router.push({ name: 'projects' });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-source {
    &__actions {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
